module.exports = __webpack_public_path__ + "media/images/country_flags/ss-64b331132713d72f860c03cfe13b6d47.png";